import moment from 'moment';
import { ExportData, ExportDataProjection } from '../models/export-data';
import { HttpService } from './http';
export class ExportDataService {
  static async getExportData(partner) {
    try {
      const data = await HttpService.get('v2', '/partners/export_data', [], [], null, partner ? {
        partner: partner.code
      } : {});
      return data.map(parseExportData);
    } catch (err) {
      console.error('[ExportDataService][getExportData]', err);
      throw err;
    }
  }
  static async getExportDataProjections(partner) {
    try {
      const data = await HttpService.get('v2', '/export_data_allowed_projections', [], [], null, partner ? {
        partner: partner.code
      } : {});
      return data.map(parseExportDataProjection);
    } catch (err) {
      console.error('[ExportDataService][getExportDataProjections]', err);
      throw err;
    }
  }
}
export function parseExportData({
  id,
  created,
  type,
  model,
  description,
  title,
  tabler_export
}) {
  return new ExportData(id, moment(created), type, model, description, title, tabler_export);
}
export function parseExportDataProjection({
  id,
  title,
  srid
}) {
  return new ExportDataProjection(id, title, srid);
}